/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Player_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Type a name or VEKN ID..." |
*
* @param {Add_Player_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const add_player_search_placeholder = /** @type {((inputs?: Add_Player_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Player_Search_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tapez un nom ou un VEKN ID...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Escriba un nombre o ID VEKN...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Digite um nome ou VEKN ID...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Digita un nome o VEKN ID...")
	return /** @type {LocalizedString} */ ("Type a name or VEKN ID...")
});